import type { SessionStepDto } from '../../schemas/sessionSchemas';

// Ration Card Verification step (Protean ration-card lookup).
export function isRationStep(step: SessionStepDto) {
  return /ration/i.test(step.stepType) || /ration/i.test(step.displayName);
}

// A 12-digit Aadhaar number (the gateway's AadhaarNumber regex).
export function isValidAadhaar12(value: string): boolean {
  return /^\d{12}$/.test(value.trim());
}
